import React from "react";
import {
  withStyles,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { withSnackbar } from "notistack";
import ReturnShipmentGrid from "./Grid/index";
import styles from "./styles";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import MESSAGES from "../../../../../appMessages";
import { SearchBar } from "../../RouteExecution/DispatchPanel/EquipmentDefects/Grid/components";
import Events from "../../../../../utilities/EventEmitter";
import appConstants from "../../../../../appConstants";

class ReturnShipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      returnShipments: [],
      quickFilterText: "",
      showLoader: true,
      gridErrorMessage: "loading",
    };
  }

  componentDidMount() {
    Events.on("OpenReturnShipments", this.toggleReturnShipmentsModel);
  }

  componentWillUnmount() {
    Events.off("OpenReturnShipments", this.toggleReturnShipmentsModel);
  }

  fetchReturnShipmentsData = () => {
    if (!this.state.open) {
      return;
    }
    const terminalCode = this.props.userProfile.terminal.code;
    getDataWithQueryString(
      "GetReturnShipments",
      `terminalCode=${terminalCode}`
    ).then((res) => {
      if (res.status === 200) {
        this.setState({
          returnShipments: res.data,
          showLoader: false,
          gridErrorMessage: appConstants.GRID_STATUS.SUCCESS,
        });
      } else {
        this.handleError();
      }
    });
  };

  toggleReturnShipmentsModel = () => {
    this.setState(
      (prevState) => ({
        open: !prevState.open,
        quickFilterText: "",
      }),
      this.fetchReturnShipmentsData
    );
  };

  updateQuickFilterText = (event) => {
    this.setState({
      quickFilterText: event.target.value,
    });
  };

  handleError = () => {
    this.props.enqueueSnackbar(MESSAGES.COMMON.LOADING_DATA, {
      variant: "error",
    });
    this.setState({
      showLoader: false,
      gridErrorMessage: appConstants.GRID_STATUS.ERROR,
      returnShipments: [],
    });
  };

  render() {
    const { classes } = this.props;
    const { theme } = this.props.userProfile || {};
    const { open, showLoader, quickFilterText, gridErrorMessage } = this.state;
    const disableSectionClass = showLoader ? classes.disableSection : null;
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="return-shipments"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${
            theme === "dark" ? "darkTheme" : "lightTheme"
          } `}
        >
          <DialogTitle
            disableTypography
            handleClose={this.toggleReturnShipmentsModel}
            id="return-shipments"
            classes={{ root: classes.dialogTitle }}
          >
            <Grid xs={2}>
              <span className={classes.dialogTitleText}>Return Shipments</span>
            </Grid>
            <Grid xs={4} className={disableSectionClass}>
              <SearchBar updateQuickFilterText={this.updateQuickFilterText} />
            </Grid>
            <Grid xs={3} className={classes.closeButton}>
              <IconButton
                aria-label="close"
                onClick={this.toggleReturnShipmentsModel}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <ReturnShipmentGrid
              returnShipments={this.state.returnShipments}
              quickFilterText={quickFilterText}
              gridErrorMessage={gridErrorMessage}
              showLoader={this.state.showLoader}
              userProfile={this.props.userProfile}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default compose(withSnackbar, withStyles(styles))(ReturnShipments);
